import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { useAgentStudioPermissions, type AgentStudioPermission } from '../lib/permissions';

interface PermissionBoundaryProps {
  permission: AgentStudioPermission | AgentStudioPermission[];
  children: ReactNode;
  fullPage?: boolean;
}

export function PermissionBoundary({ permission, children, fullPage = false }: PermissionBoundaryProps) {
  const { hasAny, isReady } = useAgentStudioPermissions();
  const requested = Array.isArray(permission) ? permission : [permission];

  if (!isReady) return null;
  if (hasAny(...requested)) return <>{children}</>;

  const content = (
    <div className="flex flex-1 items-center justify-center bg-cloud p-8">
      <div className="max-w-md rounded-2xl border border-line bg-white p-8 text-center shadow-soft">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-danger/10 text-danger">
          <ShieldX className="h-6 w-6" />
        </div>
        <h1 className="mt-4 text-lg font-semibold text-ink">Acesso não liberado</h1>
        <p className="mt-2 text-sm text-slate">
          Seu perfil não possui a permissão necessária para acessar esta área do Agent Studio.
        </p>
        <Link
          to="/home"
          className="mt-5 inline-flex rounded-xl bg-navy px-4 py-2 text-sm font-medium text-white hover:bg-navy/90"
        >
          Voltar ao Sistema Interno
        </Link>
      </div>
    </div>
  );

  return fullPage ? <div className="flex min-h-screen bg-cloud">{content}</div> : content;
}
